var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileCollapsedArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3593 1.03549C13.0051 0.723067 12.4308 0.723067 12.0766 1.03549L7.27578 5.2698L2.47496 1.03549C2.12074 0.723067 1.54644 0.723067 1.19223 1.03549C0.838008 1.34791 0.838008 1.85444 1.19223 2.16686L6.63441 6.96686C6.98863 7.27928 7.56293 7.27928 7.91715 6.96686L13.3593 2.16686C13.7136 1.85444 13.7136 1.34791 13.3593 1.03549Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCollapsedArrowIcon);
export default __webpack_public_path__ + "static/media/profile-collapsed-arrow-icon.792b47f72f719d3514374df51bcd2114.svg";
export { ForwardRef as ReactComponent };